<template>
  <div>
    <div class="app-content content devcontent">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
          <div class="container-fluid">
            <div class="row breadcrumbs-top">
              <div class="col-md-12 content-header-left px-0">
                <h3 class="content-header-title float-left mb-0">
                  Support
                </h3>
                <div class="breadcrumb-wrapper">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/support/tickets"
                        >Tickets</router-link
                      ></li>
                    <li class="breadcrumb-item">Ticket Configuration</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="content-body">
          <vue-element-loading :active="isLoading" :is-full-screen="true" />
          <section>
            <div class="card">
              <div
                class="card-header bg-white border-bottom_eee pt-1 px-1 mb-0 common_top_title_searchbgst_dock"
              >
                <div class="w-auto px-0 mobile-padding-0-2">
                  <div
                    class="avatar bg-light-secondary rounded d-inline-flex mr-1"
                  >
                    <div class="avatar-content">
                      <em class="las la-ticket-alt i_icon_st font-medium-5"></em>
                    </div>
                  </div>

                  <h4 class="card-title d-inline-flex ml-0 mb-0">
                    Add Ticket Configuration
                  </h4>
                </div>
              </div>
              <div class="col-lg-12 mt-1">
                <div class="card text-center mb-1">
                  <div
                    class="card-card-header text-editar_discription_jobs masters_detailstabing_pills px-0"
                  >
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                        <label class="form-label text-left w-100" for="department"> Department <span class="requiredField">*</span></label>
                        <treeselect placeholder="--- SELECT ---" id="department" v-model="formData.department_id" :options="department_list" />
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                        <label class="form-label text-left w-100" for="query-type"> Query/Category Type <span class="requiredField">*</span></label>
                        <treeselect placeholder="--- SELECT ---" id="query-type" v-model="formData.query_id" multiple :options="query_list" />
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                        <label class="form-label text-left w-100" for="priority"> Priority <span class="requiredField">*</span></label>
                        <treeselect placeholder="--- SELECT ---" id="priority" v-model="formData.priority" :options="priority_list" />
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                        <label class="form-label text-left w-100">Resolution Time</label>
                        <div class="row mx-0">
                          <div class="col-4 col-sm-4 col-md-4 col-lg-4 mb-1 dock_resolution_timeselect">
                            <treeselect class="" placeholder="DD" id="resolution_time_dd" v-model="formData.resolution_time.dd" :options="day_list" />
                          </div>
                          <div class="col-4 col-sm-4 col-md-4 col-lg-4 mb-1  dock_resolution_timeselect">
                            <treeselect class="" placeholder="HH" id="resolution_time_dd" v-model="formData.resolution_time.hh" :options="hour_list" />
                          </div>
                          <div class="col-4 col-sm-4 col-md-4 col-lg-4 mb-1 dock_resolution_timeselect">
                            <treeselect class="" placeholder="MM" id="resolution_time_dd" v-model="formData.resolution_time.mm" :options="minute_list" />
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                        <label class="form-label text-left w-100">Response Time</label>
                        <div class="row mx-0">
                           <div class="col-4 col-sm-4 col-md-4 col-lg-4 mb-1 dock_resolution_timeselect">
                            <treeselect class="" placeholder="DD" id="response_time_dd" v-model="formData.response_time.dd" :options="day_list" />
                           </div>
                          <div class="col-4 col-sm-4 col-md-4 col-lg-4 mb-1 dock_resolution_timeselect">
                            <treeselect class="" placeholder="HH" id="response_time_dd" v-model="formData.response_time.hh" :options="hour_list" />
                          </div>
                          <div class="col-4 col-sm-4 col-md-4 col-lg-4 mb-1 dock_resolution_timeselect">
                            <treeselect class="" placeholder="MM" id="response_time_dd" v-model="formData.response_time.mm" :options="minute_list" />
                          </div>
                         
                          
                        </div>
                      </div>
                      <div class="col-12 col-sm-6 col-md-4 col-lg-4 text-left mb-1 home_das_all_buttons_style mobileview_b_8  mobileview_b_8_ticket_btns mt-2">
                          <button type="submit" class="btn btn-outline-primary  waves-effect  mr-0" :disabled="!validateForm()" @click="saveData">
                              Submit
                          </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Quagga from "quagga";
import "vue2-datepicker/index.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import VueElementLoading from "vue-element-loading";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import searchMasterNameList from "../../../utils/searchMasterNameList";
import common_methods from "../../../utils/common_methods";
import axios from "axios"

export default {
  name: "AddTicket",
  mixins: [searchMasterNameList, common_methods],
  data() {
    return {
      isLoading: false,
      department_list: [],
      query_list: [],
      day_list: [],
      hour_list: [],
      minute_list: [],
      priority_list: [
        {
          id: 'Low',
          label: 'LOW'
        },
        {
          id: 'medium',
          label: 'MEDIUM'
        },
        {
          id: 'high',
          label: 'HIGH'
        }
      ],
      formData: {
        department_id: null,
        query_id: null,
        priority: null,
        resolution_time: {
          dd: '01',
          hh: '00',
          mm: '00'
        },
        response_time: {
          dd: '01',
          hh: '00',
          mm: '00'
        }
      }
    };
  },
  components: {
    DatePicker,
    Treeselect,
    Loading,
    VueElementLoading,
    VueTimepicker,
  },
  mounted() {
    if (!localStorage.getItem("reloaded")) {
      localStorage.setItem("reloaded", "1");
      location.reload();
    }
    if (feather) {
      feather.replace({
        width: 14,
        height: 14,
      });
    }
    $(window).on("load", function () {
      if (feather) {
        feather.replace({
          width: 14,
          height: 14,
        });
      }
    });
  },
  created() {
    this.getDropDownData()
  },
  methods: {
    getDropDownData() {
      this.getDepartmentList()
      this.getQueryList()
      this.loadTimeList()
    },
    loadTimeList() {
      this.day_list = Array.from({ length: 100 }, (_, index) => ({ id: index.toString().padStart(2, '0'), label: index.toString().padStart(2, '0') }))
      this.hour_list = Array.from({ length: 60 }, (_, index) => ({ id: index.toString().padStart(2, '0'), label: index.toString().padStart(2, '0') }))
      this.minute_list = Array.from({ length: 60 }, (_, index) => ({ id: index.toString().padStart(2, '0'), label: index.toString().padStart(2, '0') }))
    },
    getDepartmentList() {
      this.searchNameMasterList('departments', 'department_name', null, 'department_id')
        .then(result => {
          this.department_list = result.data
        })
        .catch(e => {
          this.displayError(e)
        })
    },
    getQueryList() {
      this.searchNameMasterList('query_type', 'query_name', null, 'query_id')
        .then(result => {
          this.query_list = result.data
        })
        .catch(e => {
          this.displayError(e)
        })
    },
    onSelectFile(e) {
      this.formData.files = e.target.files
    },
    resetForm() {
      let formData = this.formData
      formData.department_id = null
      formData.query_id = null
      formData.priority = null
      formData.response_time = {
        dd: '01',
        hh: '00',
        mm: '00'
      }
      formData.resolution_time = {
        dd: '01',
        hh: '00',
        mm: '00'
      }
    },
    validateForm() {
      let formData = this.formData
      if(!formData.department_id || !formData.priority) {
        return false
      }
      if(!formData.query_id || (formData.query_id && !formData.query_id.length)) {
        return false
      }
      return true
    },
    saveData() {
      console.log(this.formData)
      this.isLoading = true
      let url = "/support/tickets/add-ticket-configuration"
      let payload  = { ...this.formData }
      payload.resolution_time = Number(payload.resolution_time.dd) * 24 * 60 + Number(payload.resolution_time.hh) * 60 + Number(payload.resolution_time.mm)
      payload.response_time = Number(payload.response_time.dd) * 24 * 60 + Number(payload.response_time.hh) * 60 + Number(payload.response_time.mm)
      this.makeRequest("POST", url, payload)
        .then(result => {
          this.isLoading = false
          if(result && result.data && result.data.status) {
            this.resetForm()
            this.sweetAlertSnackbar(result.data.message, 'success')
          } else {
            this.sweetAlertSnackbar(result.data.message, 'error')
          }
        })
        .catch(e => {
          this.displayError(e)
        })
    }
  },
};
</script>
<style scoped>
.alignment {
  margin-left: 20px;
  margin-bottom: 20px;
}
.requiredField {
  margin-left: 2px;
  color: red;
}

</style>
